export const MODEL_BODYSUIT = {
  DONUT_DRIVE: "https://store.redbrick.land/ipx/avatar/bodysuit/bs_halloween_cupcake.glb",
  DONUT_DRIVE_TEST: "https://store.redbrick.land/ipx/avatar/bodysuit/bs_halloween_cupcake.glb",
  DEV_DONUT_DRIVE: "https://store.redbrick.land/ipx/avatar/bodysuit/bs_halloween_cupcake.glb",

  RUNNERZ: "https://store.redbrick.land/ipx/avatar/bodysuit/bs_runnerz_001.glb",
  DEV_RUNNERZ: "https://store.redbrick.land/ipx/avatar/bodysuit/bs_runnerz_001.glb",
  NEWYORK: "https://store.redbrick.land/ipx/avatar/bodysuit/bs_newyork_newyorker.glb",

  TEST: "asset/ipx_model/bodysuit_0008_001.glb",
};

export const AVATAR_MODEL = {
  // RPM
  0: "asset/rpm/avatar/default_0.glb",
  1: "asset/rpm/avatar/default_1.glb",
  2: "asset/rpm/avatar/default_2.glb",
  3: "asset/mingle/avatar/bear.gltf",
  4: "asset/mingle/avatar/bear_01.gltf",
  5: "asset/mingle/avatar/bear_02.gltf",
  // 5: "asset/mingle/avatar/mingleAvatar.glb",
};

export const MODEL_ANIMATION = {
  IPX: "https://store.redbrick.land/ipx/avatar/bodysuit/animations.glb",
};

export const ANIMATION_MAP = {
  IPX: {
    map: {
      BOOST: 3,
      DANCING: 30,
      DESSERT_EAT: 17,
      DESSERT_SMELL: 15,
      GROUND_SIT: {
        start: 12,
        loop: 13,
        end: 14,
      },
      HALLOWEEN_BASKET: 11,
      HALLOWEEN_CANDY: 10,
      HALLOWEEN_SCARE: 9,
      HI: 24,
      IDLE: 8,
      JUMP: {
        start: 5,
        loop: 6,
        end: 7,
      },
      LOSE: 25,
      PICK: 16,
      RUN: 4,
      SELFIE: {
        start: 18,
        loop: 19,
        end: 20,
      },
      SIT: {
        start: 0,
        loop: 1,
        end: 2,
      },
      THUMBS_UP: 29,
      WIN: 26,
      WOAH: 27,
      WOO: 28,
    },
    type: "label",
    model: "ipx",
  },
  RPM: {
    map: {
      IDLE: "asset/rpm/animation/idle_opt.glb",
      JUMP: "asset/rpm/animation/jump_new.glb",
      RUN: "asset/rpm/animation/run_new.glb",
      FALL: "asset/rpm/animation/fall_new.glb",
      BOOST: "asset/rpm/animation/boost_new.glb",
    },
    type: "individual",
    model: "rpm",
  },
  RPM_FPS: {
    map: {
      IDLE: "asset/rpm/animation/rifle_idle_opt.glb",
      JUMP: "asset/rpm/animation/rifle_jump_opt.glb",
      RUN: "asset/rpm/animation/rifle_run_opt.glb",
    },
    type: "individual",
    model: "rpm_fps",
  },
  BERA: {
    map: {
      IDLE: "asset/mingle/animation/bear_idle.glb",
      JUMP: "asset/mingle/animation/bear_jump.glb",
      RUN: "asset/mingle/animation/bear_run.glb",
      BOOST: "asset/mingle/animation/bear_fastrun.glb",
      FALL: "asset/mingle/animation/bear_falling.glb",
    },
    type: "individual",
    model: "bear",
  },
  // MINGLE: {
  //   map: {
  //     IDLE: "asset/mingle/animation/mingle_run.glb",
  //     JUMP: "asset/mingle/animation/mingle_run.glb",
  //     RUN: "asset/mingle/animation/mingle_run.glb",
  //   },
  //   type: "individual",
  //   model: "mingle",
  // },
};

export const CALIBRATION_MAP = {
  IPX: {
    bodyHeightFactor: {
      top: 1.55,
      bot: 1.45,
    },
    capsuleHeight: 0.48,
    capsuleOffset: -1.37,
    capsuleRadius: 0.2,
    rayLength: {
      top: 0.9,
      bot: 1.5,
      jump: 1.1,
      col: 2.14,
    },
    rayPosBottomOffset: {
      v: -0.8,
      h: 0.4,
    },
    rayPosOffset: {
      top: 0.7,
      bot: 0.5,
    },
    rayPosTopOffset: {
      v: 1.1,
      h: 0.9,
    },
    rotation: {
      x: 0,
      y: 1,
      z: 0,
      radian: 3.14,
    },
    scale: {
      x: 3,
      y: 3,
      z: 3,
    },
  },
  RPM: {
    bodyHeightFactor: {
      top: 1.55,
      bot: 1.45,
    },
    capsuleHeight: 1.33,
    capsuleOffset: -2.28,
    capsuleRadius: 0.21,
    rayLength: {
      top: 0.9,
      bot: 1.5,
      jump: 1.1,
      col: 2.14,
    },
    rayPosBottomOffset: {
      v: -0.8,
      h: 0.4,
    },
    rayPosOffset: {
      top: 0.7,
      bot: 0.5,
    },
    rayPosTopOffset: {
      v: 1.1,
      h: 0.9,
    },
    rotation: {
      x: 0,
      y: 1,
      z: 0,
      radian: 0,
    },
    scale: {
      x: 2.5,
      y: 2.5,
      z: 2.5,
    },
  },
  BERA: {
    bodyHeightFactor: {
      top: 1.55,
      bot: 1.45,
    },
    capsuleHeight: 1,
    capsuleOffset: -2.28,
    capsuleRadius: 0.23,
    rayLength: {
      top: 0.9,
      bot: 1.5,
      jump: 1.1,
      col: 2.14,
    },
    rayPosBottomOffset: {
      v: -0.8,
      h: 0.4,
    },
    rayPosOffset: {
      top: 0.7,
      bot: 0.5,
    },
    rayPosTopOffset: {
      v: 1.1,
      h: 0.9,
    },
    rotation: {
      x: 0,
      y: 1,
      z: 0,
      radian: 0,
    },
    scale: {
      x: 3,
      y: 3,
      z: 3,
    },
  },
};

export const SOCKET_MAP = {
  IPX: {
    leftHand: {
      l_hand_socket_01: [
        {
          initialVisibility: false,
          name: "halloween_candy",
          url: "asset/ipx_model/redbrick_candy.glb",
        },
      ],
    },
    rightHand: {
      r_hand_socket_01: [
        {
          initialVisibility: false,
          name: "selfie_stick",
          url: "asset/ipx_model/redbrick_selfiestick.glb",
        },
        {
          initialVisibility: false,
          name: "halloween_basket",
          url: "asset/ipx_model/redbrick_basket.glb",
        },
      ],
    },
  },
};
export const donutNpcSettings = [
  {
    model: `asset/ipx_model/bodysuit_0008_001.glb`,
    fixed: false,
    name: "name01",
    status: "QUEST",
    position: {x: -145, y: 18, z: -1273},
    rotation: {x: 0, y: Math.PI / 6, z: 0},
    scale: {x: 6, y: 6, z: 6},
    detectDist: 0,
    rotationCalibration: Math.PI,
    // path: [
    //   {x: -22, y: 1.8, z: -216},
    //   {x: -12, y: 1.8, z: -206},
    //   {x: -22, y: 1.8, z: -216},
    // ],
    path: null,
    textSet: [""],
    defaultAnimation: 28,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "NEXT",
    },
  },
];

export const npcSettings = [
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_096.glb`,
    fixed: false,
    name: "name01",
    status: "QUEST",
    position: {x: -12, y: 1.8, z: -216},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    // path: [
    //   {x: -22, y: 1.8, z: -216},
    //   {x: -12, y: 1.8, z: -206},
    //   {x: -22, y: 1.8, z: -216},
    // ],
    path: null,
    textSet: [
      "타임스퀘어에 오신걸 환영합니다!",
      "프렌즈스토어 앞에 포토존이 있습니다. \n셀피모드를 활용해 셀카를 찍어보세요.",
      "도로에선 항상 자동차를 조심하세요.",
      "그럼 즐거운 시간 되세요!",
    ],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "RANDOM",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_056.glb`,
    fixed: true,
    name: "name02",
    position: {x: 24.8, y: 2.5, z: -86},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 1,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "NEXT",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_060.glb`,
    fixed: true,
    name: "name03",
    position: {x: 24.8, y: 2.5, z: -81.5},
    rotation: {x: 0, y: 0, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 1,
    pathOptions: {
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "NEXT",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_061.glb`,
    fixed: true,
    name: "name04",
    position: {x: 65.8, y: 7, z: -63},
    rotation: {x: 0, y: Math.PI / 2, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: ["다음에 또 오세요!"],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_081.glb`,
    fixed: true,
    name: "name05",
    position: {x: -25, y: 1.8, z: 6},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_063.glb`,
    fixed: true,
    name: "name06",
    position: {x: -85, y: 1.8, z: -44},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_034.glb`,
    fixed: true,
    name: "name07",
    position: {x: -85, y: 1.8, z: -94},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_082.glb`,
    fixed: true,
    name: "name08",
    position: {x: -96, y: 1.8, z: -101},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_065.glb`,
    fixed: true,
    name: "name09",
    position: {x: -11, y: 1.8, z: -112},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_037.glb`,
    fixed: true,
    name: "name10",
    position: {x: -80, y: 1.8, z: -185},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_083.glb`,
    fixed: true,
    name: "name11",
    position: {x: -87, y: 1.8, z: -176},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_084.glb`,
    fixed: true,
    name: "name12",
    position: {x: 78, y: 1.8, z: -119},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_085.glb`,
    fixed: true,
    name: "name13",
    position: {x: 33, y: 1.8, z: -33},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_087.glb`,
    fixed: true,
    name: "name14",
    position: {x: 41, y: 1.8, z: -21},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_088.glb`,
    fixed: true,
    name: "name15",
    position: {x: 73, y: 7, z: -11},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_050.glb`,
    fixed: true,
    name: "name16",
    position: {x: 67, y: 5, z: -34},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: ["재고가 다 떨어졌어요.. 커피 말고 셀카는 어떠신가요?"],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_090.glb`,
    fixed: true,
    name: "name17",
    position: {x: 39, y: 1.8, z: 49},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_051.glb`,
    fixed: true,
    name: "name18",
    position: {x: 31, y: 2.5, z: -58.5},
    rotation: {x: 0, y: 0, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: ["반가워! 라인프렌즈 스토어 구경 해봤어?"],
    defaultAnimation: 1,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "NEXT",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_092.glb`,
    fixed: true,
    name: "name19",
    position: {x: 33, y: 1.8, z: -43},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_093.glb`,
    fixed: true,
    name: "name20",
    position: {x: 3, y: 1.8, z: 45},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_048.glb`,
    fixed: true,
    name: "name21",
    position: {x: -14, y: 6, z: 61},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_094.glb`,
    fixed: true,
    name: "name22",
    position: {x: -22, y: 6, z: 61},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_050.glb`,
    fixed: true,
    name: "name23",
    position: {x: 6, y: 11, z: 80},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_051.glb`,
    fixed: true,
    name: "name24",
    position: {x: -80, y: 1.8, z: 17},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_095.glb`,
    fixed: true,
    name: "name25",
    position: {x: -3, y: 13, z: 92},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_096.glb`,
    fixed: true,
    name: "name26",
    position: {x: 20, y: 1.8, z: 113},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: null,
    textSet: [""],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "TARGETXZ",
    },
  },
  {
    model: `https://store.redbrick.land/ipx/avatar/model/FZCR_056.glb`,
    fixed: false,
    name: "name27",
    position: {x: 24.8, y: 2.5, z: -86},
    rotation: {x: 0, y: Math.PI, z: 0},
    scale: {x: 3, y: 3, z: 3},
    rotationCalibration: Math.PI,
    path: [
      {x: -32, y: 1.8, z: -216},
      {x: -32, y: 1.8, z: -101},
      {x: -75, y: 1.8, z: -101},
      {x: -75, y: 1.8, z: -216},
      {x: -32, y: 1.8, z: -216},
    ],
    curveType: "catmullrom",
    tension: 0.0,
    textSet: ["안녕하세요?"],
    defaultAnimation: 8,
    pathOptions: {
      speed: 5,
      actionType: "DEFAULT",
      moveDirection: "FORWARD",
      rotationOptions: "FIXEDXZ",
      lookOptions: "NEXT",
    },
  },
];
